const logo = require('url:../../assets/logo.png')

export function LogoMarca(props: {height?: number, width?: number}) {
    return <img  src={logo} height={props.height || 100} width={props.width || 200} style={{alignSelf:"center"}} />
}